import React from 'react';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Card, CardContent, Typography } from '@mui/material';
import { COLOR_TOOLTIP_BACKGROUND } from 'src/const';

const InfoTooltipContent = ({ content }) => {
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down(900));

  return (
    <Card sx={{ width: isMobileDevice ? '80vw' : 400 }}>
      <CardContent sx={{ backgroundColor: COLOR_TOOLTIP_BACKGROUND }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {content}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InfoTooltipContent;
